import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  class: "my-auto h-[700px] w-full"
}, null, -1)
const _hoisted_2 = { class: "flex w-full items-center justify-end gap-2 px-6 py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isMapLocationModalOpened,
    "is-full-screen-modal": true,
    "no-padding": true,
    title: 
      _ctx.config.IS_PARKOM == 'true'
        ? _ctx.$t('ParkingSpaces.ParkingSpaceLocation')
        : 'Edit asset location'
    ,
    onToggleModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_the_button, {
          text: _ctx.$t('General.Save'),
          "button-type": "primaryButton",
          onExecuteMethod: _ctx.handleSubmit
        }, null, 8, ["text", "onExecuteMethod"]),
        _createVNode(_component_the_button, {
          text: _ctx.$t('General.Cancel'),
          "button-type": "oulineButton",
          onExecuteMethod: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-modal')))
        }, null, 8, ["text"])
      ])
    ]),
    _: 1
  }, 8, ["is-displayed", "title"]))
}